import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

import { ValStorageService } from './val-storage.service';
import { ValService } from './val.service';

@Injectable()
export class ValCompanyResolver implements Resolve<boolean> {
    constructor(
        private _service: ValService,
        private _s: ValStorageService,
        private _r: Router,
        private _ar: ActivatedRoute
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        if (this._s.company) { return of(true); }
        return this._service.getCompany()
            .pipe(
                take(1),
                map(data => {
                    this._s.company = data;
                    this._s.company.DeliveryAddresses.forEach(da => da.displayField = da.Address + ', ' + da.ZipCode + ', ' + da.Place)
                    return true;
                }),
                catchError(err => {
                    this._r.navigate(['login'], { relativeTo: this._ar });
                    return of(null);
                })) as Observable<boolean>;
    }
}
